import React from 'react'
import PropTypes from 'prop-types'
import Page from '../../../containers/Debit/ConfirmationPage'

const Confirmation = (props) => (
    <React.Fragment>
        <Page {...props} />
    </React.Fragment>
)

Confirmation.propTypes = {
    children: PropTypes.node
}

export default Confirmation